import { isLockFeature, isUrlValid, renderErrorValue } from '@/helpers';
import trackingPageMediaSlice, { trackingPageMediaSelector } from '@/redux/features/trackingPageMedia.slice';
import { BlockStack, InlineGrid } from '@shopify/polaris';
import { useDispatch, useSelector } from 'react-redux';
import AssetCard from './AssetCard';
import { uploadFileConfig } from './config';
import { accountSelector } from '@/redux/features/plan.slice';
import { AccountPlan } from '@/constants/enum';

interface IProps {
  isShowTrackingFormSetup?: boolean;
}

const UploadAsset = ({ isShowTrackingFormSetup }: IProps) => {
  const plan = useSelector(accountSelector);
  const isLock = isLockFeature([AccountPlan.Starter]) && !plan.isOldPaidUser;
  const dispatch = useDispatch();
  // const [loadingAsset, setLoadingAsset] = useState('');
  // const [uploadImage, uploadData] = useUploadMediaMutation();
  // const [updateUploadImage, updateUploadData] = useUpdateUploadMediaMutation();

  const trackingPageMedia = useSelector(trackingPageMediaSelector);
  const handleUploadFile = (key: string) => (file: File) => {
    if (!trackingPageMedia.data) return;
    dispatch(
      trackingPageMediaSlice.actions.handleUpdateMedia({
        data: {
          ...trackingPageMedia.data,
          [key]: {
            ...trackingPageMedia.data[key as keyof typeof trackingPageMedia.data],
            previewUrl: URL.createObjectURL(file),
            file,
          },
        },
      }),
    );
  };
  const handleChangeValue = (key: string) => (value: string) => {
    if (!trackingPageMedia.data) return;
    dispatch(
      trackingPageMediaSlice.actions.handleUpdateMedia({
        data: {
          ...trackingPageMedia.data,
          [key]: {
            ...trackingPageMedia.data[key as keyof typeof trackingPageMedia.data],
            value,
          },
        },
        validation: trackingPageMedia.validation?.filter((item) => item !== key),
      }),
    );
  };

  const handleBlurTextField = (value: string, key: string) => {
    if (value && !isUrlValid(value)) {
      const isNotHaveKey = trackingPageMedia.validation?.findIndex((item) => item === key) === -1;
      if (isNotHaveKey) {
        dispatch(
          trackingPageMediaSlice.actions.handleUpdateMedia({ validation: [...(trackingPageMedia.validation || []), key] }),
        );
      }
    } else {
      dispatch(
        trackingPageMediaSlice.actions.handleUpdateMedia({
          validation: trackingPageMedia.validation?.filter((item) => item !== key),
        }),
      );
    }
  };

  // const handleUploadSuccess = (key: string, res: any) => {
  //   const updatedState = {
  //     ...state,
  //     [key]: {
  //       ...state[key as keyof typeof state],
  //       file: null,
  //     },
  //   };

  //   setState(updatedState);
  //   setInitState(updatedState);
  //   dispatch(commonSlice.actions.handleToast(handleToastMutation(res)));
  // };

  // const handleUploadImage = (key: string) => () => {
  //   setLoadingAsset(key);
  //   const data = state[key as keyof typeof state];
  //   const initData = initState[key as keyof typeof initState];

  //   const formData = new FormData();
  //   formData.append('name', `asset-${data.index}`);
  //   if (data.file) {
  //     formData.append('file', data.file);
  //   }
  //   if (data.value) {
  //     formData.append('url', data.value);
  //   }
  //   formData.append('shop', shop);
  //   formData.append('urlParams', token?.urlParams || '');

  //   if (!data.file && data.value !== initData.value) {
  //     return updateUploadImage({ name: `asset-${data.index}`, url: data.value }).then((res) => handleUploadSuccess(key, res));
  //   }
  //   uploadImage(formData).then((res) => handleUploadSuccess(key, res));
  // };

  // const disableSaveData = useMemo(() => {
  //   const temp = [...uploadFileConfig.trackingForm, ...uploadFileConfig.trackingResult];
  //   return (
  //     temp.every((item) => {
  //       const asset = state[item.key as keyof typeof state];
  //       return !asset.value && !asset.file;
  //     }) ||
  //     temp?.some((item) => {
  //       const asset = state[item.key as keyof typeof state];
  //       const initAsset = initState[item.key as keyof typeof initState];

  //       return (
  //         (asset.value && (asset.value === initAsset.value || !isUrlValid(asset.value))) ||
  //         (asset.file && asset.file === initAsset.file)
  //       );
  //     })
  //   );
  // }, [initState, state]);

  const renderAssetCards = (
    assets: {
      key: string;
      title: string;
      size: string;
    }[],
  ) => {
    return assets.map((item, index, arr) => {
      const asset = trackingPageMedia.data?.[item.key as keyof typeof trackingPageMedia.data];
      const initAsset = trackingPageMedia.oldData?.[item.key as keyof typeof trackingPageMedia.oldData];

      return (
        <AssetCard
          key={item.key}
          assetNo={item.title}
          fileUrl={asset?.url || ''}
          fileSize={item.size}
          onUploadFile={handleUploadFile(item.key)}
          destinationValue={asset?.value || ''}
          onChangeDestination={handleChangeValue(item.key)}
          onBlurDestination={() => handleBlurTextField(asset?.value || '', item.key)}
          disabledBtn={
            (asset?.value === initAsset?.value && asset?.file === initAsset?.file && !asset?.file) ||
            !!trackingPageMedia.validation?.includes(item.key)
          }
          loadingBtn={false}
          // loadingBtn={(uploadData.isLoading || updateUploadData.isLoading) && loadingAsset === item.key}
          // onClickBtn={handleUploadImage(item.key)}
          onClickBtn={() => {}}
          error={renderErrorValue(trackingPageMedia.validation || [], item.key, 'Destination URL must be an URL address')}
          isHiddenPublishBtn
          isShowDivider={index < arr.length - 1}
          disabled={isLock}
        />
      );
    });
  };

  return (
    <>
      {isShowTrackingFormSetup ? (
        <BlockStack gap="400">{renderAssetCards(uploadFileConfig.trackingForm)}</BlockStack>
      ) : (
        <InlineGrid columns={{ xs: 1 }} gap="400">
          {renderAssetCards(uploadFileConfig.trackingResult)}
        </InlineGrid>
      )}
    </>
  );
};

export default UploadAsset;
